export enum InlineModuleTypeEnum {
	FORM = 'form',
	DOCUMENT = 'document',
}
